import collect from "collect.js";

import { useContext, useEffect, useState, createRef } from "react";
import { useTranslation } from "react-i18next";
import { LangContext } from "../context/lang-context";

import { Swiper, SwiperSlide } from "swiper/react";

import { useMediaQuery } from "react-responsive";

import isEmpty from "lodash/isEmpty";

import format from "date-fns/format";
// import getMonth from "date-fns/getMonth";
import intlFormat from "date-fns/intlFormat";
import Button from "./common/Button";

import CalendarItem from "./CalendarItem";
import Loader from "./common/Loader";
import Icon from "./Icon";

const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

const addDaysToDate = (date, days = 1) => {
  let newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
};

const interpolateDates = (startDate, endDate) => {
  startDate = new Date(startDate);

  endDate = new Date(endDate);
  endDate = addDaysToDate(endDate, 1);

  let dates = [];
  let currentDate = startDate;

  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDaysToDate(currentDate, 1);
  }

  return dates;
};

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

function CourseCalendar(props) {
  const { t } = useTranslation();
  const { locale } = useContext(LangContext);

  const isDesktop = useMediaQuery({
    query: "(min-width: 768px)",
  });

  const today = new Date();
  const dayKeys = props.data.courses.loaded
    ? Object.keys(props.data.courses.data)
    : [];

  const allDays =
    dayKeys.length > 0
      ? interpolateDates(today, dayKeys[dayKeys.length - 1])
      : [];

  const [currentMonth, setCurrentMonth] = useState(
    intlFormat(
      allDays[0],
      {
        month: "long",
        year: "numeric",
      },
      {
        locale: locale,
      }
    )
  );

  const [selectedCourses, setSelectedCourses] = useState([]);
  const forceUpdate = useForceUpdate();

  const [activeSlide, setActiveSlide] = useState(0);

  const refs = dayKeys.reduce((acc, key) => {
    acc[key] = createRef();
    return acc;
  }, {});
  const handleClick = (id, index) => {
    setActiveSlide(index);

    refs[id]?.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  const contentRef = createRef();

  return (
    <>
      <div className="tw-relative tw-h-full tw-flex tw-flex-col">
        {!isEmpty(props.data.courses.data) && (
          <div className="tw-flex-none tw-h-32 tw-bg-teal-darker tw-text-white">
            <div className="tw-p-3 tw-uppercase tw-font-black tw-font-condensed">
              <span>{props.data.base.data.name}</span>
              {props.data.courses.loaded && (
                <>
                  {" "}
                  <span className="tw-text-teal-light">{currentMonth}</span>
                </>
              )}
            </div>

            {props.data.courses.loaded && (
              <Swiper
                grabCursor={true}
                slidesPerView={isDesktop ? 12.5 : 7.5}
                slideToClickedSlide={true}
                centeredSlides={true}
                centeredSlidesBounds={true}
                centerInsufficientSlides={true}
                className="
              tw-flex tw-space-x-3 tw-px-3

              before:tw-block before:tw-absolute before:tw-inset-y-0 before:tw-right-0 before:tw-w-4 before:tw-bg-gradient-to-l before:tw-from-teal-darker before:tw-z-10 before:tw-pointer-events-none 
              
              after:tw-block after:tw-absolute after:tw-inset-y-0 after:tw-left-0 after:tw-w-4 after:tw-bg-gradient-to-r after:tw-from-teal-darker after:tw-z-10 after:tw-pointer-events-none
            "
                onActiveIndexChange={(swiper) => {
                  setCurrentMonth(
                    intlFormat(
                      allDays[swiper.activeIndex],
                      {
                        month: "long",
                        year: "numeric",
                      },
                      {
                        locale: locale,
                      }
                    )
                  );
                }}
              >
                {allDays.map((day, index) => {
                  const dateSlug = format(day, "yyyy-MM-dd");

                  return (
                    <SwiperSlide
                      key={`date_entry_${dateSlug}`}
                      className={`tw-pb-4 tw-pt-1 tw-flex tw-flex-col tw-items-center`}
                    >
                      <>
                        <div className="tw-text-xs tw-font-black">
                          {intlFormat(
                            day,
                            {
                              weekday: "short",
                            },
                            {
                              locale: locale,
                            }
                          )}
                        </div>
                        <button
                          className={`tw-mt-1 tw-w-8 tw-h-8 tw-flex tw-flex-none tw-items-center tw-justify-center tw-text-lg tw-rounded-full ${
                            dayKeys.includes(dateSlug)
                              ? "tw-font-condensed tw-font-black"
                              : "tw-line-through tw-decoration-2 tw-decoration-white/20 tw-text-white/40"
                          } ${
                            activeSlide === index /*isToday(day)*/
                              ? "tw-bg-teal"
                              : ""
                          }`}
                          onClick={() => handleClick(dateSlug, index)}
                        >
                          {intlFormat(
                            day,
                            {
                              day: "numeric",
                            },
                            {
                              locale: locale,
                            }
                          )}
                        </button>
                      </>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
        )}
        <div className="tw-flex-1 tw-relative tw-overflow-hidden">
          <div
            ref={contentRef}
            className="tw-absolute tw-inset-0 tw-p-2 tw-overflow-y-auto tw-overscroll-y-contain tw-pb-32"
          >
            {!props.data.courses.loaded && (
              <Loader className="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2" />
            )}
            {props.data.courses.loaded && (
              <>
                {isEmpty(props.data.courses.data) && (
                  <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                    <Icon
                      icon="kalender"
                      size={128}
                      className="tw-text-gray-medium"
                    />
                  </div>
                )}
                {!isEmpty(props.data.courses.data) && (
                  <>
                    <ul>
                      {Object.entries(props.data.courses.data).map(
                        ([index, dates]) => {
                          return (
                            <li
                              key={`day_${index}`}
                              ref={refs[index]}
                              className="tw-px-2 tw-pb-4"
                            >
                              <h2 className="tw-text-teal tw-font-condensed tw-font-black tw-text-xl tw-uppercase tw-italic tw-leading-5 tw-text-center tw-py-6 tw-flex tw-items-center before:tw-inline-block before:tw-h-px before:tw-flex-auto before:tw-bg-gray-medium after:tw-inline-block after:tw-h-px after:tw-flex-auto after:tw-bg-gray-medium">
                                <span className="tw-inline-block tw-px-4">
                                  {intlFormat(
                                    new Date(index),
                                    {
                                      weekday: "long",
                                      // year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    },
                                    {
                                      locale: locale,
                                    }
                                  )}
                                </span>
                              </h2>
                              <ul className="tw-space-y-2">
                                {dates.map((date, key) => {
                                  const duration = (
                                    new Date( date.date.replace(/-/g, "/") + " " + date.endzeit).getTime() -
                                    new Date(date.date.replace(/-/g, "/") + " " + date.startzeit).getTime())/60000;

                                  const onChangeFn = (event) => {
                                    if (event.target.checked) {
                                      setSelectedCourses((state) => {
                                        if (!state.includes(date.list_id))
                                          state.push(date.list_id);
                                        return state;
                                      });
                                    } else {
                                      setSelectedCourses((state) =>
                                        state.filter(
                                          (item) => item !== date.list_id
                                        )
                                      );
                                    }
                                    forceUpdate();
                                  };
                                  const isChecked = selectedCourses.includes(
                                    date.list_id
                                  );

                                  return (
                                    <CalendarItem
                                      key={date.list_id}
                                      isChecked={isChecked}
                                      data={date}
                                      duration={duration}
                                      studioName={props.data.base.data.name}
                                      onChangeFn={onChangeFn}
                                    />
                                  );
                                })}
                              </ul>
                            </li>
                          );
                        }
                      )}
                    </ul>
                    <div className="tw-text-center tw-p-5">
                      <button
                        className="tw-font-condensed tw-uppercase tw-font-black tw-font-xs"
                        onClick={() => {
                          contentRef?.current?.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                      >
                        {t("courses.back_to_top")}
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <div
            className={`tw-absolute tw-z-10 tw-bottom-0 tw-inset-x-0 tw-h-28 tw-p-5 tw-bg-teal tw-text-white tw-transition-transform ${
              selectedCourses.length > 0
                ? "tw-translate-y-0"
                : "tw-translate-y-full"
            } tw-pb-safe-bottom`}
          >
            <Button
              href={t("links.register_now") + props.shopId}
              title={t("buttons.register")}
              color="orange"
              type="fill"
              size="large"
              className="tw-w-full"
            />
            <p className="tw-mt-2 tw-text-center">
              <a
                className="tw-underline hover:tw-decoration-1"
                href={t("links.login")}
              >
                {t("courses.member_already")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CourseCalendar;
